export const queryReferralEligibilityResults = `
query GetReferral($id: ID!) {
  getReferral(id: $id) {
    id
    userId
    user {
      id
      active
      title
      userGroupId
      userGroup {
        id
        currency
      }
    }
    bonuses {
      id
      amountDue
      bonusStatus
      companyId
      contactId
      contact {
        emailAddress
        firstName
        lastName
      }
      currency
      earnedDate
      hireDate
      jobId
      job {
        externalJobId
        id
        referralBonus
        title
      }
      notes
      paidDate
      payment
      recipientType
      referralId
      startDate
      userId
      user {
        id
        accountClaimId
        accountClaim{
          id
        }
        emailAddress
        firstName
        lastName
        userGroupId
        userGroup {
          id
        }
      }
      ignoreEligibilityChecks
    }
    contactResume {
        bucket
        region
        key
    }
    eligibilityResults
  }
}
`;
